import React from "react";
import { render } from "react-dom";
import { Router, Route, Link, browserHistory, withRouter } from "react-router";
import Modal from "react-modal";

// Styles and themes
import "./styles/bootstrap.base.css";
import "./styles/bootstrap.overrides.css";
import "./styles/styles.css";
// Modules
import api from "./api.jsx";
import auth from "./auth.jsx";
import TopBar from "./web_topbar";
// Pages
import EMSMonitor from "./ems_monitor";
import ExposureMonitor from "./pos_monitor";
import PositionSearch from "./pos_search";
import InstrumentEditor from "./instrument_editor";
import AdminServices from "./admin_services";
import AdminUsers from "./admin_users";
// Constants
// window.API_ENDPOINT = 'http://localhost:8080/api'
window.API_ENDPOINT = "https://devedge.treotrade.net/api";
//window.API_ENDPOINT = '/api'
// Main App
const App = React.createClass({
  getInitialState() {
    return {
      loggedIn: auth.loggedIn(),

      isAlertOn: false,
      alertMessage: ""
    };
  },
  updateAuth(loggedIn) {
    console.log("Auth Token : ", loggedIn);
    this.setState({
      loggedIn
    });
  },
  componentWillMount() {
    // Popups, because window.alert will pause javascript execution
    Modal.setAppElement("body");
    window.raiseAlert = msg => {
      this.setState({
        isAlertOn: true,
        alertMessage: msg
      });
    };

    api();

    auth.onChange = this.updateAuth;
    if (window.location.pathname != "/login") auth.login();
  },

  render() {
    return (
      <div className="container">
        {this.state.loggedIn ? <TopBar /> : undefined}
        <div
          className="app_content"
          style={{
            position: "fixed",
            height: "calc(100% - 29px)",
            bottom: 0,
            width: "100%"
          }}
        >
          {this.state.loggedIn || window.location.pathname == "/login"
            ? this.props.children && React.cloneElement(this.props.children)
            : undefined}
        </div>

        <Modal
          isOpen={this.state.isAlertOn}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 20002,
              backgroundColor: "rgba(0, 0, 0, 0.65)"
            },
            content: {
              position: "absolute",
              top: "50%",
              left: "50%",
              right: "initial",
              bottom: "initial",
              transform: "translate(-50%,-50%)",
              border: "1px solid #cc7e2e",
              background: "rgba(0, 0, 0, 0.65)",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              borderRadius: "4px",
              outline: "none",
              padding: "20px",
              textAlign: "center"
            }
          }}
        >
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: this.state.alertMessage
              }}
            ></p>
            <br />
          </div>
          <a
            className="btn btn-primary"
            onClick={() => {
              this.setState({ isAlertOn: false });
            }}
          >
            OK
          </a>
        </Modal>
      </div>
    );
  }
});

import "./styles/login.css";
const Login = withRouter(
  React.createClass({
    getInitialState() {
      return {
        error: false
      };
    },
    handleSubmit(event) {
      event.preventDefault();

      const username = this.refs.username.value;
      const pass = this.refs.pass.value;

      delete localStorage.token;
      delete localStorage.username;
      delete localStorage.user_id;

      auth.login(username, pass, loggedIn => {
        if (!loggedIn) return this.setState({ error: true });

        const { location } = this.props;

        if (location.state && location.state.nextPathname) {
          this.props.router.replace(location.state.nextPathname);
        } else {
          this.props.router.replace("/");
        }
      });
    },
    render() {
      return (
        <form className="login_form" onSubmit={this.handleSubmit}>
          <label>
            <input
              ref="username"
              name="username"
              placeholder="login"
              defaultValue=""
            />
          </label>
          <label>
            <input
              ref="pass"
              name="password"
              type="password"
              placeholder="password"
            />
          </label>
          <br />
          <button type="submit">login</button>
          {this.state.error && <p>Invalid Credential</p>}
        </form>
      );
    }
  })
);

function requireAuth(nextState, replace) {
  if (!auth.loggedIn()) {
    replace({
      pathname: "/login",
      state: { nextPathname: nextState.location.pathname }
    });
  }
}

const Logout = React.createClass({
  componentDidMount() {
    auth.logout();
  },

  render() {
    return <p>You are now logged out</p>;
  }
});

// Main App
document.addEventListener("DOMContentLoaded", () => {
  render(
    <Router history={browserHistory}>
      <Route path="/" component={App}>
        <Route path="login" component={Login} />
        <Route path="logout" component={Logout} />
        <Route
          path="ems_monitor"
          component={EMSMonitor}
          onEnter={requireAuth}
        />
        <Route
          path="pos_monitor"
          component={ExposureMonitor}
          onEnter={requireAuth}
        />
        <Route
          path="pos_search"
          component={PositionSearch}
          onEnter={requireAuth}
        />
        <Route
          path="instrument_editor"
          component={InstrumentEditor}
          onEnter={requireAuth}
        />
        <Route
          path="admin_services"
          component={AdminServices}
          onEnter={requireAuth}
        />
        <Route
          path="admin_users"
          component={AdminUsers}
          onEnter={requireAuth}
        />
      </Route>
    </Router>,
    document.body
  );
});



// WEBPACK FOOTER //
// ./src/app.jsx